import React, { Component } from "react";
import { Select } from "@material-ui/core";
import styled from "styled-components";

const StyledSelect = styled(Select)`
    .MuiSelect-root {
        background: white !important;
        font-family: "Source Sans Pro", sans-serif;
    }

    .MuiSelect-select {
        text-transform: ${props => props.uppercase ? "uppercase" : "capitalize"};
        padding: ${props => props.small ? "5px 20px 5px 10px" : "6px 32px 6px 12px"};
        font-size: ${props => props.small ? "11px" : "13px"};

        .tooltip-badge {
            display: none;
        }
    }
`;

export class Dropdown extends Component {
    render() {
        const { onChange, overrideStyledSelect = {}, variant = "outlined", children, value, ...props } = this.props;

        return (
            <StyledSelect
                style={{
                    ...overrideStyledSelect
                }}
                variant={variant}
                value={value == "mixed" ? "" : value}
                className="bai-dropdown"
                {...props}
                onChange={event => onChange(event.target.value)}
                displayEmpty

                renderValue={value => {
                    if (value === "") {
                        return <em>Mixed</em>;
                    }
                    // For non-empty values, find and return the content of the matching MenuItem
                    // Other
                    const selectedChild = React.Children.toArray(children).find(child =>
                        React.isValidElement(child) && child.props.value === value
                    );
                    return selectedChild ? selectedChild.props.children : value;
                }}
            >
                {children}
            </StyledSelect>
        );
    }
}

